<template>
<div>
    <div v-if="saveMessage !== ''" class="alert alert-primary alert-dismissible fade show" role="alert">
        {{saveMessage}}
        <button @click="clearSaveMessage" type="button" class="close" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="card shadow mb-4">
        <div class="card-header py-3">
            <h6 class="m-0 font-weight-bold text-primary">Translations</h6>
        </div>
        <div class="card-body">
            <div class="table-responsive">
                <b-table
                    show-empty
                    striped
                    :items="orderedTranslations"
                    :fields="fields"
                    >
                        <template v-slot:cell(key)="row">
                            {{row.value}}
                        </template>
                        <template v-slot:cell(value)="row">
                            <b-input v-if="!checkIfTextAreaNeeded(row)"
                            class="form-control"
                            :state="isValid(row)" type="text" v-model="row.item.value" @change="editTranslation(row)" @click="setCurrentEdited(row.index)">
                            </b-input>
                            <b-textarea v-if="checkIfTextAreaNeeded(row)"
                            class="form-control"
                            :state="isValid(row)" type="text" v-model="row.item.value" @change="editTranslation(row)" @click="setCurrentEdited(row.index)">
                            </b-textarea>
                        </template>
                </b-table>
            </div>
            <b-pagination-nav 
                v-model="currentPage" 
                :link-gen="linkGeneration" 
                :number-of-pages="totalPages" 
                use-router 
                align="center"
                :first-text="this.$t('PAGING_FIRST_PAGE')"
                :last-text="this.$t('PAGING_LAST_PAGE')" >
            </b-pagination-nav>
        </div>
    </div>
</div>

    
</template>

<script>
    import { funcs } from '../../../i18n';
    import pagingMixin from './../../../mixins/pagingMixin'

    export default {
        mixins: [ pagingMixin ],
        data() {
            return {
                translations: [],
                saveIndicators: [],
                saveMessage: '',
                currentPage: null,
                totalTranslations: 0,
                totalPages: 1,
            }
        },
        computed: {
            fields() {
                return [
                    { key: 'key', label: 'Key', sortable: true },
                    { key: 'value', label: 'Value' },
                ]
            },
            orderedTranslations() {
                return this.translations.sort((a, b) => (a.key > b.key) ? 1 : ((b.key > a.key) ? -1 : 0));
            }
        },
        methods: {
            isValid: function (row) {
                let valid = this.saveIndicators[row.index]
                if (valid) return true
                else return null
            },
            setCurrentEdited: function (index) {
                this.currentEdited = index
            },
            getLanguageTranslations: function () {
                let self = this
                let langCode = this.$route.params.langCode

                this.$http.get(`/api/languages/${langCode}/translations`)
                    .then(response => {
                        self.translations = response.data
                    })
                    .catch(error => {
                    })
            },
            addTranslationRow: function () {
                this.translations.push({
                    'key': '',
                    'value': ''
                })
            },
            editTranslation: function (row) {
                let self = this
                let translation = row.item
                translation['languageCode'] = this.$route.params.langCode
                this.$http.put(`/api/languages/${translation.key}/edit`, translation)
                    .then(response => {
                        let language
                        this.$store.getters.systemLanguages.forEach(lang => {
                            if (lang.title === translation['languageCode']) {
                                language = lang
                            }
                        })
                        let messages = this.$i18n.messages[translation.languageCode]
                        messages[translation.key] = translation.value
                        this.$i18n.setLocaleMessage(translation.languageCode, messages)
                        self.saveIndicators[row.index] = true
                        this.$forceUpdate()
                        setTimeout((index) => {
                            self.saveIndicators[index] = null
                            this.$forceUpdate()
                        }, 3000, row.index)
                    })
                    .catch(error => {
                        self.saveIndicators[row.index] = false
                        console.log(error)
                    })
            },
            saveTranslations: function () {
                this.translations.forEach((element) => {
                    element['languageCode'] = this.$route.params.langCode
                })
                this.requestEdit()
            },
            requestEdit: function () {
                let langCode = this.$route.params.langCode
                this.$http.put(`/api/languages/${langCode}/save`, {
                    'translations': this.translations
                }).then(response => {
                    this.saveMessage = 'Changes saved successfully!'
                })
                    .catch(error => {
                        this.saveMessage = 'There was a problem saving your changes'
                    })
            },
            getLanguageTranslationsCount: function () {
                let self = this
                let langCode = this.$route.params.langCode
                this.$http.get(`/api/languages/translations/${langCode}/count`)
                    .then(response => {
                        self.totalTranslations = response.data
                        self.totalPages = this.calculateNumberOfPages(self.totalTranslations);
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            loadLanguageTranslations: function () {
                let self = this;
                let langCode = this.$route.params.langCode
                this.$http.get(`/api/languages/translations/${langCode}/` + this.currentPage)
                    .then(response => {
                        if (self.translations.length == 0) {
                            self.getLanguageTranslationsCount()
                        }
                        self.translations = response.data
                        let i = 0
                        for (let item in self.translations) {
                            self.saveIndicators[i] = null
                            i++
                        }
                    })
                    .catch(error => {
                        console.log(error);
                    })
            },
            clearSaveMessage: function () {
                this.saveMessage = ''
            },
            linkGeneration: function (pageNumber) {
                return {
                    path: this.$route.path,
                    query: { p: pageNumber }
                }
            },
            checkIfTextAreaNeeded: function (row) {
                return row.item.key.endsWith('_TEXT');
            }
        },
        created: function () {
            this.currentPage = this.$route.query.p ? Number(this.$route.query.p) : 1;
        },
        watch: {
            saveIndicators: function (value) {
                if (value === true) {
                    this.$forceUpdate()
                }
            },
            currentPage: function () {
                this.loadLanguageTranslations();
            }
        }
    }</script>

<style lang="scss" scoped>
    table {
        .rounded-circle {
            height : 2rem;
            width : 2rem;
        }
    }
    b-input:before {
        font-family: FontAwesome;
        top:0;
        left:-5px;
        padding-right:10px;
        content: "\f058"; 
    }
    b-input {
        position: relative;
    }
</style>
